<template>
<l-marker :key="data.mac" :lat-lng="data.latlng" @click="detail">
  <l-tooltip>
    <gateway-header :data="data" :isDisconnected="isDisconnected"></gateway-header>
  </l-tooltip>
</l-marker>
</template>

<script>
import GatewayItemHeader from './GatewayItemHeader'

import {
  LMarker,
  LTooltip
} from 'vue2-leaflet';

export default {
  name: 'GatewayMapMarker',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    LMarker,
    LTooltip,
    'gateway-header': GatewayItemHeader
  },
  computed: {
    isDisconnected() {
      let now = new Date().getTime();
      let diff = now - this.data.updatedTime;
      return (diff > 10 * 60 * 1000);
    }
  },
  methods: {
    detail() {
      this.$emit('detail', this.data.mac);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/gateway/MapMarker.vue